import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const SchoolContext = createContext();

export const useSchool = () => {
  const context = useContext(SchoolContext);
  if (!context) {
    throw new Error('useSchool must be used within a SchoolProvider');
  }
  return context;
};

// Provides the list of schools an admin can pick from. Which school is
// *currently* being viewed/managed lives entirely in the URL
// (/admin/:schoolId/...) — see AdminDashboard.js and SchoolSelect.js —
// rather than in this context, localStorage, or a request header. That
// keeps the current school explicit, bookmarkable, and shareable.
export const SchoolProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSchools = useCallback(async () => {
    try {
      const response = await axios.get('/api/admin/schools');
      setSchools(response.data.schools || []);
    } catch (error) {
      console.error('Error fetching schools:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      fetchSchools();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, fetchSchools]);

  const value = {
    schools,
    loading,
    refetch: fetchSchools
  };

  return (
    <SchoolContext.Provider value={value}>
      {children}
    </SchoolContext.Provider>
  );
};
